import { configureStore } from '@reduxjs/toolkit'

import rootReducer from 'presentation/redux/reducers'

export default configureStore({
  reducer: rootReducer,
})
